import { render } from "./UploadProfesores.vue?vue&type=template&id=e9c17636&scoped=true"
import script from "./UploadProfesores.vue?vue&type=script&lang=js"
export * from "./UploadProfesores.vue?vue&type=script&lang=js"

import "../assets/bootstrap.min.css?vue&type=style&index=0&id=e9c17636&scoped=true&lang=css"
import "./UploadProfesores.vue?vue&type=style&index=1&id=e9c17636&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c17636"]])

export default __exports__